export const ADD_TO_CART = 'cart:add'
export const REMOVE_FROM_CART = 'cart:remove'
export const CLEAR_CART = 'cart:clear'
export const UPDATE_QUANTITY = 'cart:update'
export const SET_COUPON = 'cart:coupon:set'
export const SET_DISCOUNT_CODE = 'cart:discount-code:set'
export const SET_REFERRAL = 'cart:referral:set'
export const SET_CHANNEL = 'cart:channel:set'
